<template>
<div class="chapter">
<div class="inner_page">
<div>
<span href="#/Text/Section0038#alink13" title="Link target outside of Sample"></span><br/>
</div>
<div class="center"><img alt="" src="Images/9781932033939_pic0002.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?7d253efe